"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContext = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
/**
 * @hidden
 */
exports.ModalContext = React.createContext({});
//# sourceMappingURL=modalContext.js.map